import styled from 'styled-components';
import {
  advisorSpentShare,
  fmtAdvisorMonth,
  fmtUsd,
  type AdvisorUsage,
} from '@entities/progress';

/* Счётчик лимита Эксперта: потрачено из лимита за месяц, полоса, остаток. */

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  min-width: 200px;
`;

const Line = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  white-space: nowrap;
`;

const Strong = styled.span`
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: 600;
  font-variant-numeric: tabular-nums;
`;

const Track = styled.div`
  height: 6px;
  border-radius: ${({ theme }) => theme.radius.pill};
  background: ${({ theme }) => theme.colors.surfaceHover};
  overflow: hidden;
`;

const Fill = styled.div<{ $share: number; $tone: 'ok' | 'warn' | 'over' }>`
  height: 100%;
  width: ${({ $share }) => `${Math.round($share * 100)}%`};
  border-radius: inherit;
  background: ${({ $tone, theme }) =>
    $tone === 'over'
      ? theme.colors.status.danger
      : $tone === 'warn'
        ? theme.colors.status.warning
        : theme.colors.status.success};
  transition: width ${({ theme }) => theme.motion.base} ${({ theme }) => theme.motion.easeOut};
`;

export function UsageMeter({ usage }: { usage: AdvisorUsage | undefined }) {
  if (!usage) {
    return (
      <Wrap aria-busy>
        <Line>Лимит месяца…</Line>
        <Track />
      </Wrap>
    );
  }
  const share = advisorSpentShare(usage);
  const tone = usage.exhausted ? 'over' : share >= 0.8 ? 'warn' : 'ok';
  return (
    <Wrap
      title={`Лимит на ${fmtAdvisorMonth(usage.month)}. Модель: ${usage.model}. Новый лимит — с 1-го числа.`}
    >
      <Line>
        <span>
          <Strong>{fmtUsd(usage.spent_usd)}</Strong> из {fmtUsd(usage.limit_usd)}
        </span>
        <span>{usage.exhausted ? 'лимит исчерпан' : `осталось ${fmtUsd(usage.remaining_usd)}`}</span>
      </Line>
      <Track
        role="meter"
        aria-label="Израсходовано лимита за месяц"
        aria-valuemin={0}
        aria-valuemax={usage.limit_usd}
        aria-valuenow={usage.spent_usd}
      >
        <Fill $share={share} $tone={tone} />
      </Track>
    </Wrap>
  );
}
